import React, { Fragment, useEffect } from "react";
import setCookie, { deleteCookie, verifyCookie } from "../utils/setCookie";
import { runRedirect } from "../utils/validUrlRedirect";
import { useSearchParams } from "react-router-dom";
import generateJwt3 from "../services/generateJwt3";
import config from "../config/config";

const VerifyCookieUser = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let cancelled = false;

    const checkCookieAndCommunicate = async () => {
      const url = searchParams.get("urlRedirect");
      const appCode = searchParams.get("appCode");

      // Solo ejecuta si cumple las condiciones
      if (
        url ||
        appCode ||
        config.ANCESTOR_ORIGIN_ME === document.referrer ||
        config.ANCESTOR_ORIGIN_ME_DECLARATIONS === document.referrer ||
        config.ANCESTOR_ORIGIN_ME_MIGRATION === document.referrer ||
        config.ANCESTOR_ORIGIN_ME_EVENTANILLA === document.referrer ||
        config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA === document.referrer
      ) {
        console.log("ANCESTOR ORIGIN REFERRER:::", document.referrer);
        console.log(
          "Target Origin - Guardado por variable de entorno::: ",
          config.ANCESTOR_ORIGIN_ME,
          config.ANCESTOR_ORIGIN_ME_DECLARATIONS,
          config.ANCESTOR_ORIGIN_ME_MIGRATION,
          config.ANCESTOR_ORIGIN_ME_EVENTANILLA,
          config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA
        );
        console.log("Cookies almacenadas", document.cookie);

        const cookie = await verifyCookie();

        if (cancelled) return; // evita actualizar si se desmontó

        if (cookie) {
          console.log("Existe cookie syserrepar_JWT2 guardada");

          if (!appCode && config.ANCESTOR_ORIGIN_ME !== document.referrer)
            return runRedirect(url, { jwt2: cookie }, appCode);

          const response = await generateJwt3(cookie, appCode ? appCode : "ME");
          if (cancelled) return;

          console.log("response generateJWT3:::: ", response);
          if (response.code === 302) {
            deleteCookie();
            setCookie(response?.jwt3);
            console.log("JWT3 a enviar desde la verificación de cookie:::", response?.jwt3);
            window.parent.postMessage(
              { token: response?.jwt3 },
              config.ANCESTOR_ORIGIN_ME
            );
            return;
          }

          // Otros orígenes posibles
          if (config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA === document.referrer)
            window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA);
          if (config.ANCESTOR_ORIGIN_ME_DECLARATIONS === document.referrer)
            window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME_DECLARATIONS);
          if (config.ANCESTOR_ORIGIN_ME_MIGRATION === document.referrer)
            window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME_MIGRATION);
          window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME);
          return;
        }

        console.log("NO EXISTE COOKIE SYSERREPAR ALMACENADA");

        // Repite los postMessage para el caso negativo
        if (config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA === document.referrer)
          window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA);
        if (config.ANCESTOR_ORIGIN_ME_DECLARATIONS === document.referrer)
          window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME_DECLARATIONS);
        if (config.ANCESTOR_ORIGIN_ME_MIGRATION === document.referrer)
          window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME_MIGRATION);
        if (config.ANCESTOR_ORIGIN_ME_EVENTANILLA === document.referrer)
          window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME_EVENTANILLA);
        if (window.parent[0])
          window.parent.postMessage({ token: "login" }, config.ANCESTOR_ORIGIN_ME);

        return;
      }
    };

    checkCookieAndCommunicate();

    return () => {
      cancelled = true;
    };
  }, []);

  return <Fragment />;
};

export default VerifyCookieUser;
